<template>
	<div id="UserAccount" class="box">
		<div class="center" v-if="user.loaded != true">
			<LoadingSpinner />
		</div>
		<div>
			<UserPhoto />
			<UserDetails />
		</div>
	</div>
</template>

<script>
	import LoadingSpinner from './LoadingSpinner.vue';
	import UserPhoto from './UserPhoto.vue';
	import UserDetails from './UserDetails.vue';

	export default {
		name: 'UserAccount',
		components: {
			LoadingSpinner,
			UserPhoto,
			UserDetails,
		},
		data() {
			return {
				user: window.portal.user,
			}
		},
	}
</script>

<style>
	#UserAccount { color: var(--box-text-color); fill: currentColor; position: relative; }
	#UserPhoto { color: var(--box-text-color); fill: currentColor; width: 200px; display: inline-block; position: relative; vertical-align: top; }
	#UserDetails { display: inline-block; width: calc(100% - 240px); margin-left: 40px; }
	@media only screen and (max-width: 800px) {
		#UserPhoto { margin-top: 0px !important; }
		#UserDetails form .block { width: auto; display: block; }
	}
	@media only screen and (max-width: 650px) {
		#UserPhoto { display: block; width: auto; max-width: auto; padding: 25px; text-align: center; max-width: 300px; margin: 20px auto; }
		#UserDetails { display: block; width: auto; max-width: auto; padding: 0 0 25px; margin-left: 0; }
	}
</style>